"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.UnderlinedTextField = void 0;

var _react = require("@fluentui/react");

var _TextField = require("@fluentui/react/lib/TextField");

var _UnderlinedTextField = require("./UnderlinedTextField.styles");

/**
 * Represents a text field that Allows for the label to be above when underlined
 */
var UnderlinedTextField = (0, _react.styled)(_TextField.TextField, _UnderlinedTextField.getStyles, undefined, {
  scope: 'UnderlinedTextField'
});
exports.UnderlinedTextField = UnderlinedTextField;